/**
 * Docs — "Was this page helpful?" widget.
 *
 * On a Yes/No click: highlight the choice, lock the buttons, swap the prompt
 * for a thank-you, remember the vote in localStorage (so we don't keep
 * asking), and record it server-side via admin-ajax. Degrades to a no-op if
 * the markup or AJAX config is absent.
 */
export function initDocsHelpful() {
	const widget = document.querySelector('.helpful[data-doc]');
	if (!widget) return;

	const docId = widget.dataset.doc;
	const prompt = widget.querySelector('span');
	const buttons = Array.from(widget.querySelectorAll('.helpful-btn'));
	if (buttons.length < 2) return;

	const storeKey = 'chadaDocHelpful:' + docId;
	const thanks = widget.dataset.thanks || 'Thanks for your feedback!';

	function lockTo(vote) {
		buttons.forEach((btn) => { btn.disabled = true; });
		(vote === 'up' ? buttons[0] : buttons[1]).classList.add('picked');
		if (prompt) prompt.textContent = thanks;
	}

	// Already voted in this browser → restore the resolved state, don't re-ask.
	let prior = null;
	try { prior = localStorage.getItem(storeKey); } catch (e) { /* private mode */ }
	if (prior === 'up' || prior === 'down') {
		lockTo(prior);
		return;
	}

	buttons.forEach((btn, index) => {
		btn.addEventListener('click', () => {
			if (btn.disabled) return;
			const vote = index === 0 ? 'up' : 'down';
			lockTo(vote);

			try { localStorage.setItem(storeKey, vote); } catch (e) { /* private mode */ }

			if (typeof window.chadaDocs !== 'undefined') {
				const body = new URLSearchParams({
					action: 'chada_doc_helpful',
					nonce: window.chadaDocs.nonce,
					doc: docId,
					vote,
				});
				fetch(window.chadaDocs.ajaxurl, {
					method: 'POST',
					credentials: 'same-origin',
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
					body: body.toString(),
				}).catch(() => { /* the local state already reflects the vote */ });
			}
		});
	});
}
